import EditMap from "./editMap";

export default EditMap;
